























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import Layout from '@/layouts/_DefaultLayoutWithCard.vue';
import DefineSystem from '@/use-cases/red-mat-calculation/DefineSystem.vue';
import SetExperimentalStds from '@/use-cases/red-mat-calculation/SetExperimentalStds.vue';
import SetIrradiatedAtoms from '@/use-cases/red-mat-calculation/SetIrradiatedAtoms.vue';
import SubmitOptions from '@/use-cases/red-mat-calculation/SubmitOptions.vue';
import { IS_ERROR, MESSAGE } from '../../use-cases/red-mat-calculation/RedMatCalculationModule';

export default Vue.extend({
  name: 'RedMatCalculationEdit',
  components: {
    Layout,
    DefineSystem,
    SetExperimentalStds,
    SetIrradiatedAtoms,
    SubmitOptions,
  },
  computed: {
    ...mapGetters({
      isError: IS_ERROR,
      message: MESSAGE,
    }),
    currentStep() {
      return this.$store.state.redMatCalculation.currentEditStep;
    },
  },
});
